module.exports = __webpack_public_path__ + "static/media/nodejs.d3929e00.png";